import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { store } from '../../store/store';
import { sendPost } from '../../api/sendPost';
import { buildOptions } from '../../utils/buildOptions/buildOptions';
import { validateParams } from '../../utils/validateParams/validateParams';
import { validateTemplateParams } from '../../utils/validateTemplateParams/validateTemplateParams';
import { isHeadless } from '../../utils/isHeadless/isHeadless';
import { headlessError } from '../../errors/headlessError/headlessError';
import { isBlockedValueInParams } from '../../utils/isBlockedValueInParams/isBlockedValueInParams';
import { blockedEmailError } from '../../errors/blockedEmailError/blockedEmailError';
import { isLimitRateHit } from '../../utils/isLimitRateHit/isLimitRateHit';
import { limitRateError } from '../../errors/limitRateError/limitRateError';
/**
 * Send a template to the specific EmailJS service
 * @param {string} serviceID - the EmailJS service ID
 * @param {string} templateID - the EmailJS template ID
 * @param {object} templateParams - the template params, what will be set to the EmailJS template
 * @param {object} options - the EmailJS SDK config options
 * @returns {Promise<EmailJSResponseStatus>}
 */

export var send = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(serviceID, templateID, templateParams, options) {
    var opts, publicKey, blockHeadless, storageProvider, blockList, limitRate, params;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            opts = buildOptions(options);
            publicKey = opts.publicKey || store.publicKey;
            blockHeadless = opts.blockHeadless || store.blockHeadless;
            storageProvider = store.storageProvider || opts.storageProvider;
            blockList = _objectSpread(_objectSpread({}, store.blockList), opts.blockList);
            limitRate = _objectSpread(_objectSpread({}, store.limitRate), opts.limitRate);

            if (!(blockHeadless && isHeadless(navigator))) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", Promise.reject(headlessError()));

          case 8:
            validateParams(publicKey, serviceID, templateID);
            validateTemplateParams(templateParams);

            if (!(templateParams && isBlockedValueInParams(blockList, templateParams))) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", Promise.reject(blockedEmailError()));

          case 12:
            _context.next = 14;
            return isLimitRateHit(location.pathname, limitRate, storageProvider);

          case 14:
            if (!_context.sent) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", Promise.reject(limitRateError()));

          case 16:
            params = {
              lib_version: '4.3.3',
              user_id: publicKey,
              service_id: serviceID,
              template_id: templateID,
              template_params: templateParams
            };
            return _context.abrupt("return", sendPost('/api/v1.0/email/send', JSON.stringify(params), {
              'Content-type': 'application/json'
            }));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function send(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();